import React from "react";
import HighlightIcon from "@material-ui/icons/Highlight";

export default function Header() {
  return (
    <header>
      <h1>
        <HighlightIcon />
        Notes
      </h1>
    </header>
  );
}
